import { all, getContext, put } from 'redux-saga/effects';
import { batchActions } from 'redux-batched-actions';
import { setPassengers } from './passengers/actions';
import { documentsSagas } from './documents/sagas';
import { getInitialPassengersState } from '../lib/getInitialPassengersState';
import { shouldSkipPassengers } from '@shared/lib/passengers';
export function* createInitialRefundState({ payload }) {
    var _a, _b;
    const { global: { companyInfo: { iataCode } } } = yield getContext('config');
    const initialValue = shouldSkipPassengers((_b = (_a = payload.travellers) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0, iataCode);
    const actions = [
        setPassengers(getInitialPassengersState(payload.travellers, initialValue))
    ];
    yield put(batchActions(actions));
}
export function* refundSagas() {
    yield all([documentsSagas()]);
}
